import { render, staticRenderFns } from "./connect.vue?vue&type=template&id=18dc8280&scoped=true"
import script from "./connect.vue?vue&type=script&lang=js"
export * from "./connect.vue?vue&type=script&lang=js"
import style0 from "./connect.vue?vue&type=style&index=0&id=18dc8280&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dc8280",
  null
  
)

export default component.exports